import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {CdkAccordion, CdkAccordionItem} from '@angular/cdk/accordion';
import {NgClass} from '@angular/common';
import {PracticeService} from '../../services/practice/practice.service';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {PracticeModel} from '../../models/practice/practice.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from "@angular/material/dialog";
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {PracticeCreateComponent} from '../practice-create/practice-create.component';

@Component({
	selector: 'app-practice-administration',
    imports: [
        CdkAccordion,
        CdkAccordionItem,
        NgClass,
        PracticeCreateComponent
    ],
	templateUrl: './practice-administration.component.html',
	styleUrl: './practice-administration.component.sass'
})
export class PracticeAdministrationComponent implements OnInit, OnDestroy {
	private destroy$ = new Subject<void>();
	practiceList: PracticeModel[] = [];
    isPracticeCreate: boolean = false;
    practiceEditId: string = '';

	constructor(
		private practiceService: PracticeService,
		private dialog: MatDialog
	) {
	}

	ngOnInit(): void {
		this.getPracticeList();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

    triggerPracticeCreate(reloadList: boolean = false): void {
        if(reloadList) {
            this.getPracticeList();
        }
        this.isPracticeCreate = !this.isPracticeCreate;
    }

    triggerPracticeEdit(id: string): void {
        if (this.practiceEditId === id) {
            this.practiceEditId = '';
            this.getPracticeList();
        } else {
            this.practiceEditId = id;
        }
    }

	openConfirmModal(id: string): void {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            closeOnNavigation: true,
            disableClose: true,
            data: {text:'Soll die Praxis wirklich gelöscht werden ?', header: 'Löschen', delete: true}
		})

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.deletePractice(id);
            }
        })
    }

	private getPracticeList(): void {
		this.practiceService.getPracticeList()
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (response: iResponseList<PracticeModel>) => {
					this.practiceList = response.data;
				},
				error: (error) => {
					console.error(error)
				}
			})
	}

	private deletePractice(id: string): void {
		this.practiceService.deletePractice(id)
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: (response: iResponse<PracticeModel>) => {
					this.getPracticeList();
				},
				error: (error) => {
					console.error(error)
				}
			})
	}
}
